import React from 'react';

// No translation required, only for debugging purposes
export const UnknownStep = ({ step = '' }) => (
  <span>Unknown step {step}</span>
);
